import { FormData } from './types';

/**
 * Creates initial form values for the collector modal by merging data from multiple sources
 * @param editEstimates - Existing estimates data when editing (optional)
 * @param isEditMode - Whether the modal is in edit mode (vs create mode)
 * @returns FormData object with merged values, prioritizing editEstimates
 */
export const createInitialFormValues = (
  editEstimates: any,
  isEditMode: boolean,
): FormData => ({
  estimateName: editEstimates?.estimateName || "",
  utilityName: editEstimates?.utilityName || "",
  estimateType: editEstimates?.estimateType || "",
  estimateHeadCount: editEstimates?.estimateHeadCount || "",
  estimateUsage: isEditMode ? editEstimates?.estimateUsage || "0" : editEstimates?.estimateUsage || "",
  estimateUsageUnit: editEstimates?.estimateUsageUnit || "",
  estimateStartDate: editEstimates?.estimateStartDate || "",
  estimateEndDate: editEstimates?.estimateEndDate || "",
  scope: editEstimates?.scope || "",
  estimateSource: editEstimates?.estimateSource || "",
  notes: editEstimates?.notes || "",
});

/**
 * Generates the appropriate modal title based on the current mode
 * @param isNotesOnlyMode - Whether the modal is in notes-only editing mode
 * @param isEditMode - Whether the modal is in edit mode (vs create mode)
 * @returns The appropriate title string for the modal
 */
export const getModalTitle = (isNotesOnlyMode: boolean, isEditMode: boolean): string => {
  if (isNotesOnlyMode) return "Edit Notes";
  if (isEditMode) return "Parameter Based Estimates";
  return "New Parameter Based Estimates";
};
